import {Entry} from './Entry';

export class Income extends Entry {
	constructor() {
		super(...arguments);

		this.type = 'income';
	}
}
